import Checkbox from '@mui/material/Checkbox';
import { Box } from '@mui/system';
import type { DashboardT } from 'business/definitions';
import DashboardItemWrapper from 'modules/decision/components/DashboardItemWrapper/DashboardItemWrapper';

type Props = {
    changeSelection: (slug: string) => void;
    isSelected: boolean;
    dashboard: DashboardT;
    isCurrentDashboard: boolean;
    shouldInsertChartBelow: boolean;
    toggleInsertChartBelow: () => void;
    insertBelowLabel: string;
};

function AddToDashboardItem({
    changeSelection,
    isSelected,
    dashboard,
    isCurrentDashboard,
    shouldInsertChartBelow,
    toggleInsertChartBelow,
    insertBelowLabel,
}: Props) {
    return (
        <>
            <DashboardItemWrapper
                dataTitle={dashboard.title}
                onClick={() => {
                    changeSelection(dashboard.slug);
                }}
            >
                <Checkbox
                    data-testid={dashboard.title}
                    className="selection-checkbox"
                    defaultChecked
                    onChange={() => changeSelection(dashboard.slug)}
                    value={dashboard.slug}
                    checked={isSelected}
                />
                <div
                    className="dashboard-title"
                    onChange={() => changeSelection(dashboard.slug)}
                    role="button"
                    tabIndex={0}
                >
                    {dashboard.title}
                </div>
            </DashboardItemWrapper>
            {isCurrentDashboard && isSelected && (
                <Box sx={{ alignItems: 'center', display: 'flex', m: '10px' }}>
                    <Checkbox
                        className="selection-checkbox"
                        checked={shouldInsertChartBelow}
                        onChange={toggleInsertChartBelow}
                    />
                    <div className="dashboard-title" role="button">
                        {insertBelowLabel}
                    </div>
                </Box>
            )}
        </>
    );
}

export default AddToDashboardItem;
